<template>
    <v-dialog v-model="dialog" width="100%"  persistent>
        <v-card>

            <v-app-bar class="mb-5" flat color="transparent">
                <v-btn large icon>
                    <v-icon color="primary" @click="$emit('close')">mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-title class="title">
                    Preview Nota de Serviço
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <v-btn color="primary" @click="handleSave">
                    <span>
                        Salvar
                    </span>
                </v-btn> -->

            </v-app-bar>


            <v-spacer></v-spacer>

            <v-card-text ref="printArea">
                <v-img src="@/assets/logo_delta.jpg" contain height="100" width="150" />
                <div class="invoice-wrapper">
                    <v-row no-gutters class="mb-4">
                        <v-col cols="8">
                            <h3 class="company-name">{{ invoice.emitenteRazaoSocial }}</h3>
                            <div>Logradouro: {{ invoice.emitenteLogradouro }} Cidade: {{ invoice.emitenteLocalEmissao }}</div>
                            <!-- <div>Tel: {{ invoice.emitente }}</div> -->
                            <div>CNPJ: {{ invoice.emitenteCpfOrCnpj }}</div>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <div class="invoice-meta">
                                <!-- <div><strong>Nota:</strong> {{ invoice.number }}</div> -->
                                <div><strong>Data:</strong> {{ formatDate(invoice.date) }}</div>
                                <div><strong>Prestador:</strong> {{ invoice.emitenteRazaoSocial }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row class="mt-4">
                        <v-col cols="6">
                            <div><strong>Tomador / Cliente</strong></div>
                            <div>{{ invoice.tomadorRazaoSocial }}</div>
                            <div>{{ invoice.tomadorEndereco }}</div>
                            <div>CPF/CNPJ: {{ invoice.tomadorCpfOrCnpj }}</div>
                        </v-col>
                        <!-- <v-col cols="6" class="text-right">
                            <div><strong>Serviço</strong></div>
                            <div>{{ invoice.observacao }}</div>
                            <div>Prazo: {{ invoice.service.deadline || '-' }}</div>
                        </v-col> -->
                    </v-row>

                    <v-simple-table class="mt-4">
                        <thead>
                            <tr>
                                <th class="text-left">Descrição</th>
                                <th class="text-right">Quantidade</th>
                                <th class="text-right">Valor Unit.</th>
                                <th class="text-right">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in invoice.jobItensList" :key="i">
                                <td>{{ item.descricao }}</td>
                                <td class="text-right">{{ item.quantidade }}</td>
                                <td class="text-right">{{ currency(item.precoUnitario) }}</td>
                                <td class="text-right">{{ currency(item.precoTotal) }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <v-row class="mt-4">
                        <v-col cols="6">
                            <div><strong>Observações</strong></div>
                            <div>{{ invoice?.observacao || '' }}</div>
                        </v-col>
                        <v-col cols="6" class="text-right">
                            <!-- <v-row no-gutters>
                                <v-col cols="6" class="text-right"><strong>Sub-total:</strong></v-col>
                                <v-col cols="6" class="text-right">{{ currency(notaInfo?.valueNf) }}</v-col>
                            </v-row> -->
                            <v-row no-gutters v-if="invoice.tributacao && invoice.tributacao.length > 0" class="mt-3 mb-3">
                                <v-col cols="3" class="text-right">
                                    <div>PIS: ({{ invoice.tributacao[0].pis }}%)</div>
                                    <div class="text-right">{{ currency(invoice.vlrPIS) }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right">
                                    <div>COFINS: ({{ invoice.tributacao[0].cofins }}%)</div>
                                    <div class="text-right">{{ currency(invoice.vlrCOFINS) }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right">
                                    <div>IR: ({{ invoice.tributacao[0].ir }}%)</div>
                                    <div class="text-right">{{ currency(invoice.vlrIR) }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right">
                                    <div>CSLL: ({{ invoice.tributacao[0].csll }}%)</div>
                                    <div class="text-right">{{ currency(invoice.vlrSCLL) }}</div>
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="mt-2">
                                <v-col cols="6" class="text-right"><strong>Aliquota:</strong></v-col>
                                <v-col cols="6" class="text-right">{{ currency(invoice.aliquota) }}</v-col>
                            </v-row>

                            <v-row no-gutters class="mt-2">
                                <v-col cols="6" class="text-right"><strong>Valor Liquido:</strong></v-col>
                                <v-col cols="6" class="text-right">{{ currency(invoice.vlrLiquido / 100) }}</v-col>
                            </v-row>

                            <v-row no-gutters class="mt-2">
                                <v-col cols="6" class="text-right"><strong>Total:</strong></v-col>
                                <v-col cols="6" class="text-right display-1">{{ currency(notaInfo?.valueNf) }}</v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="$emit('close')">Fechar</v-btn>
                <v-btn color="primary" @click="print">Imprimir</v-btn>
                <v-btn color="secondary" @click="downloadPDF">Exportar PDF</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    name: 'PreviewNotaFiscalServico',
    props: ['open', 'notaInfo'],
    data(){
        return {
            dialog: false,
            invoice: {
                /*
                number: "NS-2025-0001",
                date: new Date(),
                provider: "Prestador XYZ",
                company: {
                name: "Minha Empresa LTDA",
                address: "Rua Exemplo, 123 - Cidade - UF",
                phone: "(11) 99999-0000",
                cnpj: "12.345.678/0001-90"
                },
                client: {
                    name: "Cliente Exemplo SA",
                    address: "Av. Cliente, 999",
                    document: "99.999.999/0001-00"
                },
                service: {
                    description: "Consultoria técnica - implantação",
                    deadline: "7 dias úteis"
                },
                items: [
                    { description: "Horas de consultoria", quantity: 10, unitValue: 150.0 },
                    { description: "Configuração servidor", quantity: 1, unitValue: 500.0 }
                ],
                taxes: [
                { name: "ISS", rate: 0.05 } // 5%
                ],
                notes: "Pagamento em 30 dias. Esta é uma nota de serviço de exemplo."*/
            }
        }
    },

  methods: {

    calcularNota() {
        // 1. Valor bruto (somatório dos itens)
        const valorBruto = this.notaInfo.jobItensList.reduce((acc, item) => {
            return acc + (item.precoTotal || 0);
        }, 0);

        // 2. Retenções por item
        let totalRetencoes = 0;

        this.notaInfo.jobItensList.forEach(item => {
            const preco = item.precoTotal || 0;

            // Converte percentuais string → número (ex.: "6" → 6%)
            const parsePerc = v => (typeof v === "string" ? parseFloat(v.replace(",", ".")) : parseFloat(v)) || 0;

            const iss = item.iSS ? preco * (parsePerc(item.iSS) / 100) : 0;
            const inss = item.iNSS ? preco * (parsePerc(item.iNSS) / 100) : 0;
            const irrf = item.iRRF ? preco * (parsePerc(item.iRRF) / 100) : 0;
            const csll = item.cSLL ? preco * (parsePerc(item.cSLL) / 100) : 0;
            const pis = item.pIS ? preco * (parsePerc(item.pIS) / 100) : 0;
            const cofins = item.cOFINS ? preco * (parsePerc(item.cOFINS) / 100) : 0;

            totalRetencoes += iss + inss + irrf + csll + pis + cofins;
        });

        // 3. Valor líquido
        const valorLiquido = valorBruto - totalRetencoes;

        return {
            valorBruto,
            totalRetencoes,
            valorLiquido
        };
    },

    formatDate(d) {
      const date = new Date(d);
      return date.toLocaleDateString();
    },
    currency(v) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
    },
    taxAmount(rate) {
      return +(this.subtotal * rate);
    },
    print() {
      // Abre nova janela e imprime apenas a area do preview
      const printContents = this.$refs.printArea.innerHTML;
      const popup = window.open('', '_blank', 'width=900,height=700');
      const styles = `
        <style>
          body{ font-family: Arial, Helvetica, sans-serif; padding: 20px; color:#222; }
          .company-name{ margin:0; }
          table{ width:100%; border-collapse: collapse; }
          th, td{ padding:8px; border-bottom:1px solid #eee; }
          .text-right{ text-align:right; }
        </style>
      `;
      popup.document.open();
      popup.document.write(`<html><head><title>Nota de Serviço</title>${styles}</head><body>${printContents}</body></html>`);
      popup.document.close();
      // dar um tempo pequeno para o conteúdo renderizar antes de chamar print
      popup.focus();
      setTimeout(() => {
        popup.print();
        //popup.close(); // comente se quiser que a janela permaneça
      }, 300);
    },
    async downloadPDF() {
      // Gera PDF via html2canvas + jsPDF (dependências opcionais)
      try {
        const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
          import('html2canvas'),
          import('jspdf')
        ]);
        const node = this.$refs.printArea;
        const canvas = await html2canvas(node, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`${this.invoice.number || 'nota'} .pdf`);
      } catch (err) {
        console.error('Erro ao gerar PDF (verifique html2canvas e jspdf):', err);
        this.$emit('error', err);
        // fallback: usar print se html2canvas não estiver disponível
        this.print();
      }
    }
},

    watch: {
        open(v){
            this.dialog = v
        },

        notaInfo(info){
            if(info){
                this.invoice = info.notaFiscalServico[0]
            }
        }
    },

  computed: {
    subtotal() {
      return this.invoice.items.reduce((acc, it) => acc + (it.quantity * it.unitValue), 0);
    },
    totalTaxes() {
      if (!this.invoice.taxes) return 0;
      return this.invoice.taxes.reduce((acc, t) => acc + this.taxAmount(t.rate), 0);
    },
    total() {
      return this.subtotal + this.totalTaxes;
    }
  },
}
</script>

<style scoped>
.invoice-wrapper {
  color: #222;
  font-size: 14px;
}
.invoice-meta div {
  margin-bottom: 6px;
}
.display-1 {
  font-size: 1.6rem;
}
@media print {
  /* Esconde dialog/overlay de fundo se necessário */
  body * {
    visibility: visible;
  }
}
</style>